import "./App.module.css"
import logo from "../../assets/logo.svg"
import { Button, Checkbox, FormControlLabel, TextField } from "@mui/material"
import { useClipboard } from "@mantine/hooks"
import { useState } from "react"
import { BarColor } from "./App.types"

const HEADER_HEIGHT = 64
const HEADER_PADDING = 24

const isYoutubeURL = (url: string) =>
  /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/.test(
    url
  )

const App = () => {
  const clipboard = useClipboard()

  const [url, setUrl] = useState<string>("")
  const [autoplay, setAutoplay] = useState<boolean>(false)
  const [loop, setLoop] = useState<boolean>(false)
  const [fullscreen, setFullscreen] = useState<boolean>(false)
  const [modestBranding, setModestBranding] = useState<boolean>(false)
  const [disableKeyboard, setDisableKeyboard] = useState<boolean>(false)
  const [disableControls, setDisableControls] = useState<boolean>(false)
  const [barColor, setBarColor] = useState<BarColor>("red")
  const [enableSubtitles, setEnableSubtitles] = useState<boolean>(false)
  const [disableSuggestions, setDisableSuggestions] = useState<boolean>(false)

  return (
    <>
      <header
        style={{
          height: HEADER_HEIGHT,
          display: "flex",
          justifyContent: "center",
          padding: HEADER_PADDING,
        }}
      >
        <img alt="" src={logo} />
      </header>
      <div
        style={{
          height: `calc(100% - ${HEADER_HEIGHT + HEADER_PADDING}px)`,
          width: "100%",
          maxWidth: 400,
          margin: "24px auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "stretch",
        }}
      >
        <TextField
          label="Youtube URL"
          variant="filled"
          style={{ marginBottom: 24 }}
          onChange={(event) => setUrl(event.target.value)}
          value={url}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setAutoplay(event.target.checked)}
              value={autoplay}
            />
          }
          label="Autoplay"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setLoop(event.target.checked)}
              value={loop}
            />
          }
          label="Loop"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setFullscreen(event.target.checked)}
              value={fullscreen}
            />
          }
          label="Disable fullscreen"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setModestBranding(event.target.checked)}
              value={modestBranding}
            />
          }
          label="Hide YouTube logo"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setDisableKeyboard(event.target.checked)}
              value={disableKeyboard}
            />
          }
          label="Disable keyboard shortcuts"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setDisableControls(event.target.checked)}
              value={disableControls}
            />
          }
          label="Hide buttons and progress bar"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) =>
                setBarColor(event.target.checked ? "white" : "red")
              }
              value={barColor}
            />
          }
          label="White progress bar"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setEnableSubtitles(event.target.checked)}
              value={barColor}
            />
          }
          label="Enable subtitles"
          disabled={!isYoutubeURL(url)}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event) => setDisableSuggestions(event.target.checked)}
              value={barColor}
            />
          }
          label="Hide sugggested videos on pause"
          disabled={!isYoutubeURL(url)}
        />
        <Button
          onClick={() =>
            clipboard.copy(
              `https://youtube.com/embed/${url.slice(
                11
              )}?autoplay=${+autoplay}&mute=${+autoplay}&loop=${+loop}&fs=${+fullscreen}&modestbranding=${+modestBranding}&disablekb=${+disableKeyboard}&controls=${+!disableControls}&color=${barColor}&cc_load_policy=${enableSubtitles}&rel=${disableSuggestions}`
            )
          }
          style={{ marginTop: "24px" }}
          variant="contained"
          disabled={!isYoutubeURL(url)}
        >
          Copy embed URL
        </Button>
      </div>
    </>
  )
}

export default App
